import { mapGetters, mapMutations } from 'vuex';

export default {
    data() {
        return {
            selectedTypeOfReplacementCable: ''
        }
    },

    computed: {
        ...mapGetters([
            'activeProductInfo',
            'activeOfferKey'
        ]),

        ...mapGetters('content', [
            'webstoreContent',
        ]),

        showBSeries() {
            return this.selectedTypeOfReplacementCable === this.webstoreContent.vehicleCableQuestion.vg.options.b_series;
        },
        
        showCSeries() {
            return this.selectedTypeOfReplacementCable === this.webstoreContent.vehicleCableQuestion.vg.options.c_series;
        },

        filteredOffers() {
            return this.showBSeries ? this.filterBasedOnSubstring(this.activeProductInfo.offerings, 'CBL-VG-B') 
                : this.filterBasedOnSubstring(this.activeProductInfo.offerings, 'CBL-VG-C');
        }
    },

    methods: {
        ...mapMutations([
            'setActiveOfferKey'
        ]),

        setTypeOfReplacementCable(option) {
            this.selectedTypeOfReplacementCable = option
            let preselectedKey = this.findFirstOfferKey(this.filteredOffers);
            this.setActiveOfferKey(preselectedKey);
        },

        filterBasedOnSubstring(offerings, substring) {
            return Object.fromEntries(Object.entries(offerings)
                .filter(([value]) => value.productCodes[0].includes(substring))
            ) 
        },

        isCableOfferCSeries(offerKey) {
            return offerKey.includes('CBL-VG-C');
        },

        findFirstOfferKey(filteredOffers) {
            return Object.values(filteredOffers)[0].offerKey
        },
    },

    created() {
        if (this.activeOfferKey) {
            this.selectedTypeOfReplacementCable = this.isCableOfferCSeries(this.activeOfferKey) ? 
                this.webstoreContent.vehicleCableQuestion.vg.options.c_series :
                this.webstoreContent.vehicleCableQuestion.vg.options.b_series;
        } else {
            this.selectedTypeOfReplacementCable = this.webstoreContent.vehicleCableQuestion.default_option;
        }
        
    }   
}